import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

export default new VueI18n({
  locale: 'pt-BR',
  silentTranslationWarn: true,
  fallbackLocale: 'pt-BR',
  messages: {
    en: require('../locales/en.json'),
    'pt-BR': require('../locales/pt-br.json'),
    es: require('../locales/es.json')
  }
});
